export default function navAccordion() {
  const accordionButtons = document.querySelectorAll('.p-headerMenu__link--plus');
  if (!accordionButtons) return;

  accordionButtons.forEach(button => {
    button.addEventListener('click', () => {
      const contentId = button.getAttribute('aria-controls');
      const content = document.getElementById(contentId);

      if (content.getAttribute('aria-hidden') === 'true') {
        content.setAttribute('aria-hidden', 'false');
        button.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.setAttribute('aria-hidden', 'true');
        button.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = '0';
      }
    });
  });

}
